export enum FilterMode {
  SIMPLE = 'SIMPLE',
  ADVANCED = 'ADVANCED'
}
